'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _transmute = require('transmute');

var _reduxActions = require('redux-actions');

var _immutable = require('immutable');

var _ActionTypes = require('conversations-core/constants/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _entity = require('conversations-core/reducers/utils/entity');

var _entity2 = _interopRequireDefault(_entity);

var _helpers = require('conversations-core/utils/helpers');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

var _ConversationModel = require('conversations-schema/models/ConversationModel');

var _ConversationsModel = require('conversations-schema/models/ConversationsModel');

var _WidgetDataModel = require('conversations-schema/models/WidgetDataModel');

var _ChatFilterOptions = require('conversations-schema/constants/ChatFilterOptions');

var _ChatFilterOptions2 = _interopRequireDefault(_ChatFilterOptions);

var _ConversationStatusTypes = require('conversations-schema/constants/ConversationStatusTypes');

var _ConversationStatusTypes2 = _interopRequireDefault(_ConversationStatusTypes);

var _strings = require('conversations-core/constants/strings');

var _ConversationFactory = require('conversations-schema/factories/ConversationFactory');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = new _immutable.Map();

function getLastSeenCountFromLegacy(conversation) {
  var history = conversation.getIn(['chatHistory', 'history']);

  var unreadCount = history.filter(_ConversationalMessageModel.isConversationalMessage).takeUntil(function (message) {
    return (0, _helpers.matchesLegacyTimestamp)(conversation, message);
  }).size;

  return unreadCount;
}

exports.default = (0, _entity2.default)('conversations', (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.DELETE_BLOCKED_VISITOR_SUCCEEDED, function (conversations, action) {
  var channel = action.payload.channel;


  return conversations.updateIn((0, _ConversationsModel.getKeyPathOnChannel)(channel, _ConversationModel.KEY_PATHS.STATUS), function () {
    return _ConversationStatusTypes2.default.ENDED;
  });
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_ActionTypes2.default.RECEIVED_VISITOR_BLOCKED, _ActionTypes2.default.BLOCK_VISITOR_REQUEST_SUCCEEDED), function (conversations, action) {
  var channel = action.payload.channel;


  return conversations.updateIn((0, _ConversationsModel.getKeyPathOnChannel)(channel, _ConversationModel.KEY_PATHS.STATUS), function () {
    return _ConversationStatusTypes2.default.BLOCKED;
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.OPEN_CONVERSATION_FOR_NEW_CHANNEL, function (conversations, action) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      timestamp = _action$payload.timestamp;


  var conversation = conversations.get(channel);

  if (!conversation) {
    return conversations.set(channel, (0, _ConversationFactory.buildConversation)({
      channel: channel,
      chatHistory: {
        startTime: timestamp,
        endTime: timestamp
      }
    }));
  }

  return conversations.update(channel, (0, _ConversationModel.setStatus)(_ChatFilterOptions2.default.STARTED));
}), _defineProperty(_handleActions, _ActionTypes2.default.RECEIVED_VISITOR_FOR_CHANNEL, function (conversations, action) {
  var _action$payload2 = action.payload,
      channel = _action$payload2.channel,
      vid = _action$payload2.visitor.vid;


  return conversations.setIn([channel, 'vid'], vid);
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CONVERSATIONS_SUCCEEDED, function (conversations) {
  var updatedConversations = conversations.map(function (conversation) {
    var updatedConversation = conversation;

    if ((0, _helpers.hasLegacyTimestamp)(conversation)) {
      updatedConversation = updatedConversation.set('unseenCount', getLastSeenCountFromLegacy(conversation));
    }

    return updatedConversation;
  });

  return updatedConversations;
}), _defineProperty(_handleActions, _ActionTypes2.default.SET_CURRENT_CHANNEL, function (conversations, action) {
  var channel = action.payload.channel;

  var widgetConversation = conversations.get(_strings.INITIAL_ONLINE_MODE_CHANNEL);

  if (conversations.size === 1 && widgetConversation) {
    return conversations.set(channel, widgetConversation.set('channel', channel));
  }

  return conversations;
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_WIDGET_DATA_SUCCEEDED, function (conversations, action) {
  var widgetData = action.payload;

  if ((0, _WidgetDataModel.isOnlineMode)(widgetData)) {
    return conversations.set(_strings.INITIAL_ONLINE_MODE_CHANNEL, (0, _ConversationFactory.buildConversation)());
  }

  return conversations.set(_strings.OFFLINE_MODE_CHANNEL, (0, _ConversationFactory.buildOfflineModeConversation)({
    text: (0, _WidgetDataModel.getAwayMessage)(widgetData),
    richText: null,
    senderId: (0, _WidgetDataModel.getSenderId)(widgetData)
  }));
}), _defineProperty(_handleActions, _ActionTypes2.default.GET_CHAT_HISTORY_SUCCEEDED, function (conversations, action) {
  var _action$payload3 = action.payload,
      channel = _action$payload3.channel,
      messages = _action$payload3.messages,
      startTime = _action$payload3.startTime,
      endTime = _action$payload3.endTime;


  if (messages.size < 1) {
    return conversations;
  }

  return conversations.update(channel, (0, _transmute.pipe)((0, _ConversationModel.bulkAddMessages)(messages), (0, _ConversationModel.setStartTime)(startTime), (0, _ConversationModel.setEndTime)(endTime), _ConversationModel.setLatestMessage));
}), _defineProperty(_handleActions, _ActionTypes2.default.ADD_MESSAGE_TO_CONVERSATION, function (conversations, action) {
  var _action$payload4 = action.payload,
      channel = _action$payload4.channel,
      message = _action$payload4.message;


  return conversations.update(channel, (0, _transmute.pipe)((0, _ConversationModel.addMessage)(message), _ConversationModel.setLatestMessage, (0, _transmute.ifThen)(function () {
    return (0, _ConversationalMessageModel.isConversationalMessage)(message);
  }, (0, _ConversationModel.setStatus)(_ChatFilterOptions2.default.STARTED))));
}), _defineProperty(_handleActions, (0, _reduxActions.combineActions)(_ActionTypes2.default.UPDATE_MESSAGE_IN_CONVERSATION, _ActionTypes2.default.SEND_OFFLINE_MESSAGE_SUCCEEDED, _ActionTypes2.default.SEND_OFFLINE_MESSAGE_FAILED), function (conversations, action) {
  var _action$payload5 = action.payload,
      channel = _action$payload5.channel,
      message = _action$payload5.message,
      updated = _action$payload5.updated;


  return conversations.update(channel, (0, _transmute.pipe)((0, _ConversationModel.updateMessage)(message, updated), _ConversationModel.setLatestMessage, (0, _transmute.ifThen)(function () {
    return (0, _ConversationalMessageModel.isConversationalMessage)(message);
  }, (0, _ConversationModel.setStatus)(_ChatFilterOptions2.default.STARTED))));
}), _defineProperty(_handleActions, _ActionTypes2.default.END_CONVERSATION, function (conversations, action) {
  var channel = action.payload.channel;

  return conversations.update(channel, (0, _ConversationModel.setStatus)(_ChatFilterOptions2.default.ENDED));
}), _defineProperty(_handleActions, _ActionTypes2.default.INCREMENT_UNSEEN_COUNT, function (conversations, action) {
  var channel = action.payload.channel;


  return conversations.updateIn((0, _ConversationsModel.getKeyPathOnChannel)(channel, _ConversationModel.KEY_PATHS.UNSEEN_COUNT), function (unseenCount) {
    return unseenCount + 1;
  });
}), _defineProperty(_handleActions, _ActionTypes2.default.CLEAR_UNSEEN_COUNT, function (conversations, action) {
  var channel = action.payload.channel;


  return conversations.setIn((0, _ConversationsModel.getKeyPathOnChannel)(channel, _ConversationModel.KEY_PATHS.UNSEEN_COUNT), 0);
}), _handleActions), initialState));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/reducers/conversations.js
// module id = 507
// module chunks = 0